import { SetCurrentCompany, SetCurrentProperty } from '@protector/entities/core/__legacy__/redux.actions';
import { getSelectedCompanyId } from 'core/core.selectors';
import { getIsLogged } from 'core/services/auth/auth.selectors';
import { useCompanyOrOrganizationMatch, useRiskManagementMatch } from 'core/utils/hooks/usePathMatches';
import { getSelectedProperty, selectPropertyEntities } from 'entities/property/property.selectors';
import { SetSeasonsFromProperties, SetSeasonsFromProperty } from 'entities/season/season.actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router';

export const useHandlerCompanyByRouter = () => {
  const dispatch = useDispatch();
  const isLogged = useSelector(getIsLogged);
  const organization = useCompanyOrOrganizationMatch();
  const riskManagement = useRiskManagementMatch();
  const selectedOrganization = useSelector(getSelectedCompanyId);

  const organizationId = organization?.params?.companyId ?? riskManagement?.params?.companyId;

  useEffect(() => {
    if (organizationId && organizationId !== selectedOrganization && isLogged) {
      dispatch(SetCurrentCompany(organizationId));
    }
  }, [organizationId, selectedOrganization, dispatch, isLogged]);
};

export const useHandlerPropertyByRouter = () => {
  const dispatch = useDispatch();
  const selectedProperty = useSelector(getSelectedProperty);

  const router = useMatch({
    path: '/company/:companyId/property/:propertyId',
    end: false
  });

  const propertyId = router?.params?.propertyId;

  const properties = useSelector(selectPropertyEntities);

  useEffect(() => {
    if (!propertyId) {
      const allProperties = Object.values(properties);
      if (allProperties?.length) {
        dispatch(SetSeasonsFromProperties(allProperties));
      }
    }
  }, [dispatch, properties, propertyId]);

  useEffect(() => {
    dispatch(SetCurrentProperty(propertyId ?? null));
  }, [propertyId, dispatch]);

  useEffect(() => {
    if (selectedProperty) {
      dispatch(SetSeasonsFromProperty());
    }
  }, [selectedProperty, dispatch]);
};
